import { useEffect, useState } from 'react'
import { Carousel } from 'react-bootstrap';
import api from '../services/api';
import "./Home.css";
import { NavLink } from 'react-router-dom';
import ProductFilterPage from './ProductFilterPage';
import HeadingSectionLayout from '../components/Layouts/HeadingSectionLayout';

const Home = () => {
    const [banners, setBanners] = useState([]);

     useEffect(() => {
        api.get("fetch-banners").then((res) => {
            setBanners(res.data)
        });
    
      }, []);
  return (
    <div>
        <div className="slider-wrapper">
          <Carousel data-bs-theme="dark" pause={false}>
            {banners.map((item, index) => (
              <Carousel.Item key={index}>
              <img
                className="slider-image"
                src={`${process.env.REACT_APP_IMAGEBASE_URL}banners/${item.banner_img}?v=${new Date().getTime()}`}
                alt={item.banner_title}
              />
              </Carousel.Item>
            ))}
          </Carousel>
        </div>

        <HeadingSectionLayout title="ALL PRODUCTS"/>

        <ProductFilterPage />
   

        <div className="wedding-collection">
          <div>
            <HeadingSectionLayout title="Wedding Collection"/>
    

            <div className="video-wrapper">
              <video
                playsInline
                autoPlay
                loop
                muted
                preload="metadata"
                poster="https://kankatala.com/cdn/shop/files/preview_images/bd18c8df7c5942bd879f0b0de07e29c7.thumbnail.0000000000_1100x.jpg?v=1758523893"
                className="w-100"
              >
                <source
                  src="https://kankatala.com/cdn/shop/videos/c/vp/bd18c8df7c5942bd879f0b0de07e29c7/bd18c8df7c5942bd879f0b0de07e29c7.SD-480p-1.5Mbps-57981437.mp4?v=0"
                  type="video/mp4"
                />
              </video>

              {/* 🔥 Overlay Button */}
              <div className="video-overlay">
                <NavLink
                  to="/all-products"
                  className="btn btn-outline-light px-4 py-2"
                >
                  SHOP NOW
                </NavLink>
              </div>
            </div>
          </div>
        </div>      


    </div>
  )
}

export default Home